export default __webpack_public_path__ + "static/media/smallMockup12.f204e586.jpg";